import styled from "@emotion/styled";

import { DynamicHeaderSubscribeButton } from "~/components/header/dynamics";

export const Container = styled.div``;

export const FeaturesWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ActionButton = styled.div`
  &:not(:last-child) {
    margin-inline-end: 24px;
  }
`;

export const StyledDynamicHeaderSubscribeButton = styled(DynamicHeaderSubscribeButton)`
  color: #ffffff;
  font-weight: 600;
  font-size: 20px;
  line-height: 20px;
  letter-spacing: 0.05em;
  text-transform: uppercase;

  border: 4px solid #555555;
  border-radius: 100px;

  background: #555555;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 16px;
    padding-inline: 26px;
  }
`;
